import React, { Suspense, lazy } from 'react';
import {
  Routes,
  Route,
  Navigate,
  useParams,
  useLocation,
  matchPath,
} from 'react-router-dom';
import Loading from '../components/ComponentLoading';
import { useSearchParams } from 'react-router-dom';
import { ErrorBoundary as DefaultErrorBoundary } from 'react-error-boundary';
import GenericError from '../components/Error';
import { MobileOverlay } from '../components/MobileOverlay';
import { logEvent } from '../utils/appLog';

const Main = lazy(() => import('../containers/MainRouteContainer'));
const Viewer = lazy(() => import('../containers/ViewerContainer'));
const Editor = lazy(() => import('../containers/EditorContainer'));
const Share = lazy(() => import('../containers/ShareContainer'));
const Library = lazy(() => import('../containers/LibraryContainer'));
const Create = lazy(() => import('../containers/CreateContainer'));
const MobileUpload = lazy(() => import('../containers/MobileUpload'));
const Error = lazy(() => import('../components/Error'));

export default () => {
  const [searchParams] = useSearchParams();
  let showAddToCartModal = false;
  const location = useLocation();
  const isMobileUpload = matchPath(
    '/mobile_upload/:projectPK',
    location.pathname,
  );

  if (searchParams.has('action')) {
    switch (searchParams.get('action')) {
      case 'order':
        showAddToCartModal = true;
        break;
    }
  }

  const logError = (error) => {
    logEvent(error);
  };

  return (
    <DefaultErrorBoundary onError={logError} FallbackComponent={GenericError}>
      <Suspense fallback={<Loading />}>
        {!isMobileUpload && <MobileOverlay />}
        <Routes>
          <Route path="/library" element={<Library />} />
          <Route path="/maintenance" element={<Error maintenance={true} />} />
          <Route path="/" element={<Library />} />
          <Route path="/create" element={<Create />} />
          <Route
            path="/viewer/:projectPK/:pageID/:width/:height"
            element={<Viewer />}
          />
          <Route
            path="/viewer/:orderNumber/:projectPK/:pageID/:width/:height"
            element={<Viewer />}
          />
          <Route path="/share/:shareID" element={<Share />} />
          <Route path="/mobile_upload/:projectPK" element={<MobileUpload />} />
          <Route
            path="/editor/:projectID"
            element={
              <Main showAddToCartModal={showAddToCartModal}>
                <Editor />
              </Main>
            }
          />
          <Route path="/:projectID" element={<EditorRedirect />} />
        </Routes>
      </Suspense>
    </DefaultErrorBoundary>
  );
};

function EditorRedirect() {
  const { projectID } = useParams();
  const [searchParams] = useSearchParams();
  const search = searchParams.toString();
  return (
    <Navigate
      to={`/editor/${projectID}${search ? `?${search}` : ''}`}
      replace
    />
  );
}
